<template>
  <div
    class="card mt-3 w-100"
    v-if="loggedIn || !journalEntry.private"
    style="background: white"
  >
    <div class="card-body">
      <h5 class="" v-if="loggedIn">
        <span v-if="journalEntry.tib"
          ><a :href="baseUrl + '/ib/' + journalEntry.tibTag">{{
            journalEntry.tib.name
          }}</a></span
        >
        {{ journalEntry.email }}&nbsp;&lt;{{ journalEntry.firstName }}
        {{ journalEntry.lastName }}&gt;
      </h5>
      <p>{{ new Date(journalEntry.timestamp).toLocaleString() }}</p>
      <div
        v-if="journalEntry.journalType !== 'onboard'"
        class="p-2"
        v-bind:style="{
          whiteSpace: 'pre-wrap',
          borderRadius: '5px',
          backgroundColor: journalEntry.private ? '#f15ba6' : '#97f168'
        }"
      >
        {{ journalEntry.text }}
      </div>
      <div
        v-if="journalEntry.journalType === 'onboard'"
        class="p-2"
        v-bind:style="{
          whiteSpace: 'pre-wrap',
          borderRadius: '5px',
          backgroundColor: '#fefcda'
        }"
      >
        <h2>Onboarding</h2>
        <h4>Email: {{ journalEntry.email }}</h4>
        <h4>First Name: {{ journalEntry.firstName }}</h4>
        <h4>Last Name: {{ journalEntry.lastName }}</h4>
        <h4>Phone: {{ journalEntry.phone }}</h4>
      </div>
      <div class="d-flex justify-content-center">
        <button
          v-if="loggedIn && !doEdit"
          @click="doEdit = true"
          type="button"
          class="btn btn-outline-dark mt-2"
        >
          <i class="fas fa-edit"></i>&nbsp;Bearbeiten
        </button>
      </div>
      <journalEntryComponent
        v-if="doEdit"
        @cancel="doEdit = false"
        @savejournalentry="save"
        :journalEntryProperty="journalEntry"
        :loggedIn="true"
        :tp="tp"
      ></journalEntryComponent>
    </div>
  </div>
</template>

<script>
import journalEntryComponent from "@/components/journal/JournalEntryComponent.vue";
import { baseUrl } from "@/common/constants";
export default {
  name: "journalItem",
  components: {
    journalEntryComponent
  },
  data: function() {
    return {
      journalEntry: this.journalEntryProperty,
      doEdit: false,
      baseUrl: baseUrl
    };
  },
  mounted() {},
  methods: {
    save() {
      this.$emit("savejournalentry", this.journalEntry);
      this.doEdit = false;
    }
  },
  props: {
    journalEntryProperty: Object,
    indexProperty: 0,
    loggedIn: false,
    tp: Object
  }
};
</script>
